module.exports = __webpack_public_path__ + "static/media/btn_ham.1bc1ed64.svg";